// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logos_container__wYJA3 {
  animation: Logos_init__DdiYd 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Logos_titleContainer__hRjcT {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Logos_title__eW36n {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Logos_itemsContainer__4yHze {
  animation: Logos_init__DdiYd 1s;
}

.Logos_primaryLogo__uh2rS {
  width: 250px;
  height: 130px;
  object-fit: scale-down;
}

.Logos_save__\\+4\\+lM {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.Logos_Primarytitle__xsx2w {
  flex-direction: row;
}

.Logos_inputTitle__khJYi {
  margin-left: 20px;
}

.Logos_colors__eto\\+b {
  padding-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Logos_square__tAWER {
  background-color: white;
  border-radius: 10px;
  padding: 40px;
}

.Logos_colorsHeader__8A5Uc {
  display: flex;
}

.Logos_logos__35Etz {
  margin-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 5vw;
}

.Logos_logo1__S9LeB,
.Logos_logo2__YRJup {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  padding: 40px;
}

.Logos_uploaders__HKeeL {
  margin-top: 30px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Logos_uploader1__gK00U,
.Logos_uploader2__e4JVG {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2vw;
}

.Logos_labelUpload__rtEq2 {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  transition: ease 0.5s;
}

.Logos_labelUpload__rtEq2:hover {
  transform: scale(1.05);
  transition: ease 0.5s;
}

.Logos_input1__Q91e- {
  display: none;
}

.Logos_caja__TzbO4 {
  justify-content: space-between;
  width: 33%;
  height: 350px;
  box-shadow: 0 0 30px -3px rgba(0, 0, 0, 0.1);
}

.Logos_caja__TzbO4 h3 {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 1.3rem;
  margin: 0;
  font-weight: 400;
  font-family: Roboto, sans-serif;
}

h1 {
  font-family: sans-serif;
  font-weight: 200;
}

h3 {
  font-family: sans-serif;
  font-weight: 200;
}
.Logos_paletsContainers__xQyIl {
  padding-top: 60px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.Logos_paletsContainer__DxWcA {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
  width: 300px;
}

.Logos_buttonContainer__GN1m2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 30px;
  width: 100%;
  height: 100%;
}

.Logos_imagePallete__HVRbI {
  width: 100%;
  height: auto;
}

.Logos_contenedorColors__pbJME {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
}

.Logos_contenedorColor__2t4Fq {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
}

.Logos_itemDate__nc3Cw {
  color: gray;
}

.Logos_dialogContainer__Uc-Vt .MuiDialog-paper {
  padding: 10px;
  border-radius: 5px;
}

.Logos_dialogContainer__Uc-Vt .Logos_datesContainer__R-AXV {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
  font-family: Roboto, sans-serif;
}

.Logos_dialogContainer__Uc-Vt .Logos_datesContainer__R-AXV h3 {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  font-size: 1.2rem;
}

.Logos_dialogContainer__Uc-Vt .Logos_datesInputs__hghXm {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.Logos_dialogContainer__Uc-Vt .Logos_datesInputs__hghXm .Logos_dateInput__9fl6a {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
}

.Logos_dialogContainer__Uc-Vt .Logos_datesInputs__hghXm .Logos_dateInput__9fl6a .Logos_selectDate__4h2JN {
  font-family: Roboto, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  width: 80%;
  padding: 5px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid rgba(94, 94, 94, 0.49);
}

.Logos_addImage__3Jwlr {
  width: 160px;
  object-fit: scale-down;
}

/*---Información---*/

.Logos_container__wYJA3 .Logos_dataContainer__jd\\+YW {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
}

.Logos_dataContainer__jd\\+YW .Logos_tableContainer__mQPLJ {
  animation: Logos_init__DdiYd 1s;
  margin-top: 10px;
  margin-bottom: 50px;
}

.Logos_dataContainer__jd\\+YW .Logos_tableContainer__mQPLJ {
  border-radius: 10px;
  max-height: 70vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Logos_dataContainer__jd\\+YW .Logos_tableContainer__mQPLJ .Logos_iconbtn__r9gc- {
  transition: 0.3s;
  font-size: 2rem;
}

.Logos_dataContainer__jd\\+YW .Logos_tableContainer__mQPLJ .Logos_iconbtn__r9gc-:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

@keyframes Logos_init__DdiYd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Logos/index.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,+BAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.titleContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.itemsContainer {\n  animation: init 1s;\n}\n\n.primaryLogo {\n  width: 250px;\n  height: 130px;\n  object-fit: scale-down;\n}\n\n.save {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n.Primarytitle {\n  flex-direction: row;\n}\n\n.inputTitle {\n  margin-left: 20px;\n}\n\n.colors {\n  padding-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.square {\n  background-color: white;\n  border-radius: 10px;\n  padding: 40px;\n}\n\n.colorsHeader {\n  display: flex;\n}\n\n.logos {\n  margin-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  margin-bottom: 5vw;\n}\n\n.logo1,\n.logo2 {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: white;\n  border-radius: 10px;\n  padding: 40px;\n}\n\n.uploaders {\n  margin-top: 30px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.uploader1,\n.uploader2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2vw;\n}\n\n.labelUpload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  transition: ease 0.5s;\n}\n\n.labelUpload:hover {\n  transform: scale(1.05);\n  transition: ease 0.5s;\n}\n\n.input1 {\n  display: none;\n}\n\n.caja {\n  justify-content: space-between;\n  width: 33%;\n  height: 350px;\n  box-shadow: 0 0 30px -3px rgba(0, 0, 0, 0.1);\n}\n\n.caja h3 {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  font-size: 1.3rem;\n  margin: 0;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n}\n\nh1 {\n  font-family: sans-serif;\n  font-weight: 200;\n}\n\nh3 {\n  font-family: sans-serif;\n  font-weight: 200;\n}\n.paletsContainers {\n  padding-top: 60px;\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.paletsContainer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 500px;\n  width: 300px;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  margin: 30px;\n  width: 100%;\n  height: 100%;\n}\n\n.imagePallete {\n  width: 100%;\n  height: auto;\n}\n\n.contenedorColors {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: space-around;\n}\n\n.contenedorColor {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  width: 100%;\n}\n\n.itemDate {\n  color: gray;\n}\n\n.dialogContainer :global .MuiDialog-paper {\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.dialogContainer .datesContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  margin-bottom: 20px;\n  font-family: Roboto, sans-serif;\n}\n\n.dialogContainer .datesContainer h3 {\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  font-size: 1.2rem;\n}\n\n.dialogContainer .datesInputs {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n}\n\n.dialogContainer .datesInputs .dateInput {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 50%;\n}\n\n.dialogContainer .datesInputs .dateInput .selectDate {\n  font-family: Roboto, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  width: 80%;\n  padding: 5px;\n  height: 30px;\n  border-radius: 10px;\n  border: 1px solid rgba(94, 94, 94, 0.49);\n}\n\n.addImage {\n  width: 160px;\n  object-fit: scale-down;\n}\n\n/*---Información---*/\n\n.container .dataContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 500px;\n}\n\n.dataContainer .tableContainer {\n  animation: init 1s;\n  margin-top: 10px;\n  margin-bottom: 50px;\n}\n\n.dataContainer .tableContainer {\n  border-radius: 10px;\n  max-height: 70vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 2rem;\n}\n\n.dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Logos_container__wYJA3`,
	"init": `Logos_init__DdiYd`,
	"titleContainer": `Logos_titleContainer__hRjcT`,
	"title": `Logos_title__eW36n`,
	"itemsContainer": `Logos_itemsContainer__4yHze`,
	"primaryLogo": `Logos_primaryLogo__uh2rS`,
	"save": `Logos_save__+4+lM`,
	"Primarytitle": `Logos_Primarytitle__xsx2w`,
	"inputTitle": `Logos_inputTitle__khJYi`,
	"colors": `Logos_colors__eto+b`,
	"square": `Logos_square__tAWER`,
	"colorsHeader": `Logos_colorsHeader__8A5Uc`,
	"logos": `Logos_logos__35Etz`,
	"logo1": `Logos_logo1__S9LeB`,
	"logo2": `Logos_logo2__YRJup`,
	"uploaders": `Logos_uploaders__HKeeL`,
	"uploader1": `Logos_uploader1__gK00U`,
	"uploader2": `Logos_uploader2__e4JVG`,
	"labelUpload": `Logos_labelUpload__rtEq2`,
	"input1": `Logos_input1__Q91e-`,
	"caja": `Logos_caja__TzbO4`,
	"paletsContainers": `Logos_paletsContainers__xQyIl`,
	"paletsContainer": `Logos_paletsContainer__DxWcA`,
	"buttonContainer": `Logos_buttonContainer__GN1m2`,
	"imagePallete": `Logos_imagePallete__HVRbI`,
	"contenedorColors": `Logos_contenedorColors__pbJME`,
	"contenedorColor": `Logos_contenedorColor__2t4Fq`,
	"itemDate": `Logos_itemDate__nc3Cw`,
	"dialogContainer": `Logos_dialogContainer__Uc-Vt`,
	"datesContainer": `Logos_datesContainer__R-AXV`,
	"datesInputs": `Logos_datesInputs__hghXm`,
	"dateInput": `Logos_dateInput__9fl6a`,
	"selectDate": `Logos_selectDate__4h2JN`,
	"addImage": `Logos_addImage__3Jwlr`,
	"dataContainer": `Logos_dataContainer__jd+YW`,
	"tableContainer": `Logos_tableContainer__mQPLJ`,
	"iconbtn": `Logos_iconbtn__r9gc-`
};
export default ___CSS_LOADER_EXPORT___;
